import React from "react";

export const CompareContext = React.createContext<any>({
  selectedMaterials: [],
});

export const useCompare = () => {
  const context = React.useContext(CompareContext);
  if (context === undefined) {
    throw new Error("useStaticData must be used within a StaticDataProvider");
  }
  return context;
};

export const CompareProvider = ({ children }) => {
  const [selectedMaterials, setSelectedMaterials] = React.useState<any>([]);

  return (
    <CompareContext.Provider
      value={{
        selectedMaterials,
        clearAll: () => setSelectedMaterials([]),
        addMaterial: (material) => {
          setSelectedMaterials((prev) => [...prev, material]);
        },
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};
